/* @flow */
// typecheck: ignore file
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import React from 'react';
import Token from 'components/Token.jsx';
import Tokenizer from 'components/Tokenizer.jsx';
import DeprecatedTypeahead from 'components/DeprecatedTypeahead.jsx';
import { debounce } from 'lodash';

class DeprecatedTokenizerTypeahead extends React.Component {
  static propTypes = {
    value: React.PropTypes.array,
    prompt: React.PropTypes.string,
    placeholder: React.PropTypes.string,
    /* (optional) button to the right of the tokenizer */
    actionButton: React.PropTypes.element,
    tokenRenderer: React.PropTypes.func,
    autoFocus: React.PropTypes.bool,
    onChange: React.PropTypes.func,
    onInputChange: React.PropTypes.func,
  };

  static defaultProps = {
    value: [],
    tokenRenderer: datum => <Token>{datum}</Token>,
    onChange: (data) => {}, // eslint-disable-line
  };

  componentDidUpdate(prevProps: Object) {
    if (prevProps.value !== this.props.value) {
      this.refs.typeahead.updateResults();
    }
  }

  handleSelect = (datum: *) => {
    const { tokenizer } = this.refs;
    const { value } = this.props;
    const index = value.indexOf(datum);
    if (index >= 0) {
      tokenizer.remove(datum);
    } else {
      tokenizer.add(datum);
    }
    tokenizer.clearInputValue();
    tokenizer.focusInput();
  }

  handleSelectAll = (data: *[]) => {
    const { tokenizer } = this.refs;
    tokenizer.add(data);
    tokenizer.focusInput();
  }

  // HACK around using refs within render
  handleInputChange = debounce((query) => {
    if (this.refs.typeahead) {
      this.refs.typeahead.setQuery(query);
    }
  }, 200);

  // HACK around using refs within render
  // typecheck: ignore statement
  handleInputKeyDown= (event: SyntheticKeyboardEvent) => {
    if (this.refs.typeahead) {
      this.refs.typeahead.handleKeyDown(event);
    }
  }

  render() {
    const {
      value,
      prompt,
      placeholder,
      tokenRenderer,
      autoFocus,
      onChange,
      actionButton,
      ...props
    } = this.props;

    const tokenizer = (
      <Tokenizer
        ref="tokenizer"
        value={value}
        prompt={prompt}
        placeholder={placeholder}
        tokenRenderer={tokenRenderer}
        autoFocus={autoFocus}
        onChange={onChange}
        onInputChange={this.handleInputChange}
        onInputKeyDown={this.handleInputKeyDown}
      />
    );

    const controlRow = actionButton ?
      <FlexibleBlock flex="left">{tokenizer}{actionButton}</FlexibleBlock> :
      tokenizer;

    return (
      <DeprecatedTypeahead
        {...props}
        ref="typeahead"
        className={props.className}
        onSelect={this.handleSelect}
        onSelectAll={this.handleSelectAll}>
        {controlRow}
      </DeprecatedTypeahead>
    );
  }
}

export default DeprecatedTokenizerTypeahead;



// WEBPACK FOOTER //
// ./src/components/DeprecatedTokenizerTypeahead.jsx